import React, { useState } from "react";
import { Field } from "redux-form";
import { useDispatch } from "react-redux";

import { get, isArray } from "lodash";
import { getIcon } from "../../helpers/icons";
import { required } from "redux-form-validators";
import { makeProfileData } from "../../actions/storage";
import { Button, Checkbox, Input } from "../../components/Field";
import AsyncGet from "../AsyncGet";
import AsyncForm from "../AsyncForm";
import Link from "../../components/Link";
import Title from "../../components/Title";
import Spacer from "../../components/Spacer";
import Editor from "../../components/Editor";

import style from "./style.module.css";

export default function CancelMembership({ closeDialog = "" }) {

    const [checkedName, setCheckedName] = useState([]);
    const [emptyError, setEmptyError] = useState(null);
    const [step, setStep] = useState("step1");
    const dispatch = useDispatch();
    
    let title = "CANCELLING YOUR MEMBERSHIP";
    if (step === "step2") {
        title = "Why are you CANCELLING YOUR MEMBERSHIP?";
    }
    else if (step === "step3") {
        title = "CANCELLING YOUR MEMBERSHIP will mean the following:";
    }
    else if (step === "step4") {
        title = "Your MEMBERSHIP IS CANCELLED";
    }

    const handleCheckboxChange = (title, isChecked) => {
        setCheckedName((prev) => {
            if (isChecked) {
                return [...prev, title];
            }
            return prev.filter((item) => item !== title);
        });
    };

    return (
        <div className={`${style.feedback} ${style.cancelMembership} ${style.popupArea}`}>
            <div className={style.popupWrap}>
                <div className={style.sectionHeader}>
                    {
                        ["step1", "step2", "step3", "step4"].includes(step) && (
                            <Link
                                className={`${style.dialogClose}`}
                                onClick={() => {
                                    if (step === "step1") closeDialog();
                                    else if (step === "step2") setStep("step1");
                                    else if (step === "step3") setStep("step2");
                                    else if (step === "step4") dispatch(makeProfileData(""));
                                }}
                            >
                                <i className={getIcon("Arrow-left")}></i>
                            </Link>
                        )
                    }
                    <Title className="fontTeko" transform="uppercase" tag="h2">{title}</Title>
                </div>
                {
                    step === "step1" && (
                        <div className={style.sectionBody}>
                            <Editor
                                text="Are you sure you want to cancel your membership?<br>If you have any concerns or need assistance, we're here to help. Feel free to reach out to our support team.<br>If you still wish to proceed, click 'Confirm' Otherwise, click 'cancel' to continue enjoying your membership perks."
                            />
                            <Spacer size="32" />
                            <div className={style.buttonRow}>
                                <Button
                                    onClick={() => { setStep("step2") }}
                                    color="buttonPrimary"
                                    label="CONFIRM"
                                />
                                <Button
                                    onClick={closeDialog}
                                    color="buttonPrimaryWithOutBg"
                                    label="CANCEL"
                                />
                            </div>
                        </div>
                    )
                }
                {
                    (step === "step2" || step === "step3") && (
                        <AsyncForm
                            attribute="cancel_membership"
                            url="/account/cancel-membership"
                            permissionText="Cancel Membership"
                            label="Cancel Membership"
                            showToastOnSuccess={false}
                            hasGetAction={false}
                            onSave={() => {
                                setStep("step4");
                            }}
                            render={({ formValues, fetching }) => {
                                if (step === "step2") {
                                    return (
                                        <div className={style.sectionBody}>
                                            <Editor
                                                text="Lorem ipsum dolor sit amet consectetur. Sodales egestas malesuada nisl tincidunt. <br>Sed dolor posuere mauris morbi at id arcu:"
                                            />
                                            <Spacer size="32" />
                                            {
                                                emptyError !== null && (
                                                    <>
                                                        <span className={style.errorMsg}>{emptyError}</span>
                                                        <Spacer className="16" />
                                                    </>
                                                )
                                            }
                                            <div className={style.reasonList}>
                                                <AsyncGet
                                                    url="list/report-type"
                                                    permissionText="Report"
                                                    loadOnMount={true}
                                                    paramsData={{
                                                        "used_for" : "user"
                                                    }}
                                                    render={({ data }) => {
                                                        if (isArray(data.list)) {
                                                            return (
                                                                data.list.map((item, index) => {
                                                                    return (
                                                                        <div className={style.reportItem} key={`report_type_${index}`}>
                                                                            <Field
                                                                                id={`cancel_reason_${index}`}
                                                                                name={`cancel_reason[${index}]`}
                                                                                checkValue={item.title}
                                                                                component={Checkbox}
                                                                                label={item.title}
                                                                                onChange={(isChecked) => handleCheckboxChange(item.title, isChecked)}
                                                                            />
                                                                        </div>
                                                                    )
                                                                })
                                                            )
                                                        }
                                                    }}
                                                />
                                                <div className={style.reportItem}>
                                                    <Field
                                                        id="report_type_other"
                                                        name="report_type_other"
                                                        checkValue="Other"
                                                        component={Checkbox}
                                                        label="Other"
                                                        onChange={(isChecked) => handleCheckboxChange("Other", isChecked)}
                                                    />
                                                    <Spacer size="16" />
                                                </div>
                                                {
                                                    get(formValues, 'report_type_other') === "Other" && (
                                                        <Field
                                                            placeholder="Please specify."
                                                            name="cancel_reason_text"
                                                            component={Input}
                                                            validate={required()}
                                                            label="Please specify"
                                                            showcount={false}
                                                        />
                                                    )
                                                }
                                                <Spacer size="16" />
                                                <div className={style.buttonRow}>
                                                    <Button
                                                        onClick={() => {
                                                            if (checkedName.length === 0) {
                                                                return setEmptyError("Please select reason");
                                                            }
                                                            if (get(formValues, 'report_type_other') === "Other" && !get(formValues, 'cancel_reason_text')) {
                                                                return setEmptyError("Please specify");
                                                            }
                                                            setEmptyError(null);
                                                            setStep("step3");
                                                        }}
                                                        color="buttonPrimary"
                                                        label="CONFIRM"
                                                    />
                                                    <Button
                                                        onClick={closeDialog}
                                                        color="buttonPrimaryWithOutBg"
                                                        label="CANCEL"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                else if (step === "step3") {
                                    return (
                                        <div className={style.sectionBody}>
                                            {
                                                checkedName.length > 0 && (
                                                    <>
                                                        <div className={style.reasonList}>
                                                            <ul>
                                                                {
                                                                    checkedName.map((item, index) => {
                                                                        if (item !== "Other") {
                                                                            return (
                                                                                <li key={`reason_${index}`}>{item}</li>
                                                                            )
                                                                        }
                                                                        else if (item === "Other") {
                                                                            return (
                                                                                <li key={`reason_${index}`}>{get(formValues, 'cancel_reason_text')}</li>
                                                                            )
                                                                        }
                                                                        return null;
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                        <Spacer size="16" />
                                                    </>
                                                )
                                            }
                                            <div className={style.buttonRow}>
                                                <Button
                                                    submit={true}
                                                    fetching={fetching}
                                                    color="buttonPrimary"
                                                    label="CONFIRM"
                                                />
                                                <Button
                                                    fetching={fetching}
                                                    onClick={closeDialog}
                                                    color="buttonPrimaryWithOutBg"
                                                    label="CANCEL"
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                            }}
                        />
                    )
                }
                {
                    step === "step4" && ( 
                        <div className={`${style.sectionBody} ${style.finalStep}`}>
                            <Editor
                                text="Your membership to WW2 HQ has been cancelled. and we will not bill you again. Thank you for your support."
                            />
                            <Spacer size="32" />
                            <div className={style.buttonRow}>
                                <Button
                                    onClick={() => {
                                        dispatch(makeProfileData(""))
                                    }}
                                    color="buttonPrimary"
                                    label="CLOSE"
                                />
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}